import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, Divider, Fab, Paper, Skeleton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { uploadMaterial, uploadImageList, DeletedMaterial, DeletedMaterialDetail } from '../../services/material-services';
import { CssTextField } from '../layout/elements';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { NotificationManager } from 'react-notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import MatGroupSelect from './mat-group-select';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import AttributionIcon from '@mui/icons-material/Attribution';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import ProgressWait from '../layout/progress';
import HomeIcon from '@mui/icons-material/Home';
import { grey } from '@mui/material/colors';



const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}));


function MaterialNew() {
    
    const { authData, authDataGroup, authDataLang } = useAuth()
    const [isAdmin, setIsAdmin] = useState(false)
    const [statusReq, setStatusReq ] = useState(false)
    const [loading, setLoading ] = useState(false)

    const location = useLocation()
    const { state } = location

    const [ image, setImage ] = useState(null)
    const [ imageSelect, setImageSelect ] = useState(null)
    
    const [detailMaterial, setDetailMaterial] = useState(false)

    const [materialID, setMaterialID ] = useState(0)
    const [remarks, setRemarks ] = useState('')
    const [remarksEnd, setRemarksEnd ] = useState('')
    const [matName, setMatName ] = useState('')
    const [matBio, setMatBio ] = useState('')
    const [matHashTag, setMatHashTag ] = useState('')
    const [altImage, setAltImage ] = useState('')
    const [matLink, setMatLink ] = useState('')
    const [matID, setMatID ] = useState(0)
    const [matBuyID, setMatBuyID ] = useState(0)

    const [metaDisc, setMetaDisc ] = useState('')
    const [metaTitle, setMetaTitle ] = useState('')
    const [metaKeywords, setMetaKeywords ] = useState('')
    const [metaAuthor, setMetaAuthor ] = useState('')
    const [matGroupName, setMatGroupName ] = useState()
    // const [matGroup, setMatGroup ] = useState('');
    // const [metaOgImageAlt, setMetaOgImageAlt ] = useState('');

    const cssClass = useStyles()
    const navigate = useNavigate()

    
    function makeid(length) {
        let result = ''
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
        const charactersLength = characters.length
        let counter = 0
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength))
          counter += 1
        }
        return result
    }
    
    useEffect(() => {
        window.scrollTo(0, 0)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        // console.log('MaterialNew', state);
        // if (state?.matGroup){
            //     setMatGroup(state.matGroup);
        // }
        // if (state != null){
            if (state?.id){
                setStatusReq(true)
                setMatID(state?.id)
            }
            if (state?.material){
                setMaterialID(state?.material)
                setDetailMaterial(true)
                if (state?.matbuy_id){
                    setMatBuyID(state?.matbuy_id)
                }
            }
            // if (state?.mat_group){
            //     setMatGroupName(state.mat_group);
            // }else{
            // }
            if (state?.group){
                setMatGroupName(state?.group)
            }
            if (state?.hash_tag){
                setMatHashTag(state?.hash_tag)
            }else{
                setMatHashTag(makeid(20))
            }
            // if (state.group){
            // console.log("group", state?.group);
            // }

            if (state?.name){
                setMatName(state?.name)
            }
            if (state?.description){
                setRemarks(state?.description)
            }
            if (state?.image){
                setImage(state?.image)
            }
            
            if (state?.bio){
                setMatBio(state?.bio)
            }
            if (state?.alt_image){
                setAltImage(state?.alt_image)
            }
            if (state?.links){
                setMatLink(state?.links)
            }

            if (state?.meta_description){
                setMetaDisc(state?.meta_description)
            }
            if (state?.meta_og_title){
                setMetaTitle(state?.meta_og_title)
            }
            if (state?.meta_keywords){
                setMetaKeywords(state?.meta_keywords)
            }
            if (state?.meta_author){
                setMetaAuthor(state?.meta_author)
            }
        // }
        // if(imageSelect){
        //     setImage(imageSelect);
        // }
    }, [state, setStatusReq, setMatGroupName])

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageSelect(e.target.files[0])
        // console.log(e.target.files[0]);
        setImage(URL.createObjectURL(e.target.files[0]))
    }

    const handelSubmitImage = async e => {
        e.preventDefault()
        setLoading(true)
        const uploaddata = new FormData()
        if(imageSelect){
            uploaddata.append('image', imageSelect, imageSelect.name)
        }
        uploaddata.append('id', matID)
        uploaddata.append('name', matName)
        if(matBio){
            uploaddata.append('bio', matBio)
        }
        if(matLink){
            uploaddata.append('links', matLink)
        }
        if(altImage){
            uploaddata.append('alt_image', altImage)
        }
        if(remarks){
            uploaddata.append('description', remarks)
        }
        uploaddata.append('group_id', matGroupName.id)
        if(matHashTag){
            uploaddata.append('hash_tag', matHashTag)
        }
        
        if(materialID === 0){
            if(metaDisc){
                uploaddata.append('meta_description', metaDisc)
            }
            if(metaKeywords){
                uploaddata.append('meta_keywords', metaKeywords)
            }
            if(metaAuthor){
                uploaddata.append('meta_author', metaAuthor)
            }
            if(metaTitle){
                uploaddata.append('meta_og_title', metaTitle)
            }
            // uploaddata.append('meta_og_url', remarks);
            // uploaddata.append('meta_og_image', remarks);
            // uploaddata.append('meta_og_image_alt', remarks);
            
            const addNewMaterial = await uploadMaterial(authData.token, uploaddata)
            // console.log(addNewMaterial);
            if (addNewMaterial){
                NotificationManager.success('خدمات جدید به برنامه اضافه شد')
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت خدمات وجود دارد')
            }
        }else{
            
            if(remarksEnd){
                uploaddata.append('description_end', remarksEnd)
            }
            uploaddata.append('material', materialID);
            const addImageList = await uploadImageList(authData.token, uploaddata)
            // console.log(addImageList);
            if (addImageList){
                NotificationManager.success('کالای جدید به برنامه اضافه شد')
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت محصول وجود دارد')
            }
        }
        setLoading(false)
        // await uploadImageMaterial(matID, uploaddata);
    }
    
    const submitDelete = async e =>{
        setLoading(true)
        let delMaterial = null
        if(matID <= 0){
            NotificationManager.warning('لطفا نام گروه را انتخاب کنید')
            return
        }
        if(materialID === 0){
            delMaterial = await DeletedMaterial(authData.token, matID)
        }else{
            delMaterial = await DeletedMaterialDetail(authData.token, matID)
        }
        if (!delMaterial){
            NotificationManager.error('متاسفانه خطایی در زمان حذف خدمات وجود دارد')
        }else{
            NotificationManager.success('خدمات با موفقیت حذف شد')
        }
        setMatName(null)
        setLoading(false)
        navigate('/')
    }
    const handleMatGroup = (value) => {
        // console.log(value)
        setMatGroupName(value)
    };
    
    // if (loading) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
    <div style={{minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        {!detailMaterial ?
            <Link to={`/${authDataGroup?.name}/#${matHashTag}`}>
                <Avatar >
                    <HomeIcon color='primary' sx={{ fontSize: 40}}/>
                </Avatar> 
            </Link>
        :
            <Link to={`/material-detail/${authDataGroup?.name}/${matBuyID}/#${matHashTag}`}>
                <Avatar >
                    <HomeIcon color='primary' sx={{ fontSize: 40}}/>
                </Avatar> 
            </Link>
        }
        
        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            
            <Typography
                fontFamily='b_mitra' 
                component="div"
                variant="h2"
                >
                کنترل کالا
            </Typography>
            {isAdmin && statusReq &&
                <Fab variant="extended" 
                    size="small" color="secondary" 
                    aria-label="add" 
                    sx={{
                        textAlign: 'right',
                        fontFamily: 'b_mitra'
                    }}
                    onClick={submitDelete}
                    >
                    <DeleteIcon sx={{ mr: 1 }} />
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h5"
                        >
                        حذف
                    </Typography>
                </Fab>
            }
        </div>        
        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
                
              }}
            >
            <Paper elevation={3} sx={{
                display: 'block',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right',
                }} >
                {loading ?
                    <Box sx={{ width: '100%' }}>
                        <Skeleton />
                        <Skeleton variant="rectangular" width='100%' height={300} />
                        <Skeleton animation="wave" />
                        <Skeleton animation={false} />
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="rounded" width='100%' height={150} />
                    </Box>
                :   
                    <form onSubmit={handelSubmitImage}>
                        <div style={{textAlign: 'right', marginRight: 20}} >
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <input
                                        accept="image/*"
                                        style={{ display: 'none', width: '100%', height: '100%' }}
                                        id="raised-button-file"
                                        multiple
                                        type="file"
                                        onChange={onSelectFile}
                                    />
                                    <label htmlFor="raised-button-file">
                                        <Button variant="raised" component="span" >
                                            <Avatar sx={{width: '200px', height: '100px'}}
                                                src={image} />
                                        </Button>
                                    </label>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <AlignHorizontalRightIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <MatGroupSelect
                                        onChange={handleMatGroup}
                                        selectedValue={state?.group}  />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-mat-name" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                نام کالا*
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard" value={matName}
                                        onChange={ e => setMatName( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item >
                                    <CssTextField id="input-detail" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                مشخصات
                                            </Typography>
                                        )}
                                        variant="standard" value={matBio}
                                        onChange={ e => setMatBio( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item>
                                    <CssTextField id="input-hashtag" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                هشتگ*
                                            </Typography>
                                        )}
                                        variant="standard" value={matHashTag}
                                        onChange={ e => setMatHashTag( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <AttributionIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item>
                                    <CssTextField id="input-image-alt" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                نام عکس (Image Alt)
                                            </Typography>
                                        )}
                                        variant="standard" value={altImage}
                                        onChange={ e => setAltImage( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <AttachFileIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-link" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                لینک
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard"  value={matLink}
                                        onChange={ e => setMatLink( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                    <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-reamarks" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                توضیحات
                                            </Typography>
                                        )}
                                        multiline
                                        fullWidth
                                        rows={4} 
                                        className={cssClass.header_dtl}
                                        variant="standard" value={remarks}
                                        onChange={ e => setRemarks( e.target.value )} />
                                </Grid>
                            </Grid>
                            {materialID &&
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                    <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-remark-end" 
                                        label={(
                                            <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={grey[500]}
                                            >
                                                توضیحات پایانی*
                                            </Typography>
                                        )}
                                        multiline
                                        fullWidth
                                        rows={4} 
                                        className={cssClass.header_dtl}
                                        variant="standard" value={remarksEnd}
                                        onChange={ e => setRemarksEnd( e.target.value )} />
                                </Grid>
                            </Grid>
                            }
                        </div>
                        <br />
                        <Divider />
                        {!detailMaterial &&
                        <div style={{textAlign: 'right', marginRight: 20}}>
                            
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h3"
                                color={grey[500]}
                                >
                                متا تگ ها
                            </Typography>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <LocalOfferIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item>
                                    <CssTextField id="input-meta-header-tag" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                هدر (متاتگ)
                                            </Typography>
                                        )}
                                        variant="standard" value={metaTitle}
                                        onChange={ e => setMetaTitle( e.target.value )} />
                                </Grid>
                                </Grid>
                                
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                    <LocalOfferIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-meta-remarks" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                توضیحات (متاتگ)
                                            </Typography>
                                        )}
                                        multiline
                                        fullWidth
                                        rows={2} 
                                        className={cssClass.header_dtl}
                                        variant="standard" value={metaDisc}
                                        onChange={ e => setMetaDisc( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <LabelImportantIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                <CssTextField id="input-meta-keys" 
                                    fullWidth
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={grey[500]}
                                            >
                                            واژه کلیدهای اصلی (متاتگ)
                                        </Typography>
                                    )}
                                    variant="standard" value={metaKeywords}
                                    onChange={ e => setMetaKeywords( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                                <Grid item>
                                    <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item >
                                    <CssTextField id="input-meta-auture" 
                                        label={(
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={grey[500]}
                                                >
                                                نویسنده (متاتگ)
                                            </Typography>
                                        )}
                                        variant="standard" value={metaAuthor}
                                        onChange={ e => setMetaAuthor( e.target.value )} />
                                </Grid>
                            </Grid>
                        </div>
                        }
                        <br/>
                        <Divider />
                        
                        <br/>
                                    
                        <Button sx={{fontFamily: 'b_mitra', paddingLeft: 5, paddingRight: 5, margin: 5}} 
                            variant="contained" color="primary" type='submit'
                            disabled={!matName || !remarks || !matHashTag}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h4"
                                >
                                ثبت
                            </Typography>
                        </Button>
                    </form>
                }
            </Paper>
        </Box>
    </div>
    </React.Fragment>
  );
}

export default MaterialNew;
